import axios from "axios";
import { DASH_API } from "../../shared/url.consts";
import { AppInsightsErrorType } from "../../shared/insights/app-insights.consts";
import { sendAppInsightsServerError } from "../../shared/insights/app-insights.utils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ValidateOneTimePasscode } from "../../types/one-time-passcode";

export const generateOneTimePasscode = async (wisrApplicationId: string) => {
  return axios.post(
    `${DASH_API}/one-time-password/${wisrApplicationId}/generate`
  );
};

export const generateOneTimePasscodeResponse = async (
  wisrApplicationId: string
) => {
  try {
    const response = await generateOneTimePasscode(wisrApplicationId);
    if (response.status === 200 || response.status === 202) {
      return;
    } else {
      sendAppInsightsServerError(
        `Unexpected response received: ${response}`,
        AppInsightsErrorType.OTP_GENERATION
      );
      return;
    }
  } catch (err) {
    sendAppInsightsServerError(
      `error generating OTP: ${err}`,
      AppInsightsErrorType.OTP_GENERATION
    );
    throw err;
  }
};

export const fetchGenerateOneTimePasscode = createAsyncThunk(
  "one-time-passcode/generate",
  generateOneTimePasscodeResponse
);

export const validateOneTimePasscode = async ({
  wisrApplicationId,
  oneTimePassword: OneTimePassword,
}: ValidateOneTimePasscode) => {
  return axios.post(`${DASH_API}/one-time-password/validate`, {
    wisrApplicationId,
    OneTimePassword,
  });
};

export const validateOneTimePasscodeResponse = async ({
  wisrApplicationId,
  oneTimePassword,
}: ValidateOneTimePasscode) => {
  try {
    const response = await validateOneTimePasscode({
      wisrApplicationId,
      oneTimePassword,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      sendAppInsightsServerError(
        `non 200 response received: ${response}`,
        AppInsightsErrorType.OTP_VALIDATION
      );
      return;
    }
  } catch (err) {
    sendAppInsightsServerError(
      `error validating OTP: ${err}`,
      AppInsightsErrorType.OTP_VALIDATION
    );
    throw err;
  }
};

export const fetchValidateOneTimePasscode = createAsyncThunk(
  "one-time-passcode/validate",
  validateOneTimePasscodeResponse
);
